import { SortDirection } from '@/enums/sort';
import { useCallback } from 'react';
import {
    GroupTableCustomSortComparators,
    sortGroupTableWithComparators,
} from '@/components/group-tables/group-table-view-model-primitives';
import { GroupTableMetrics } from '@/components/group-tables/group-table-view-model-primitives';
import { useGroupTableViewModelCore } from '@/components/group-tables/use-group-table-view-model-core';

type UseGroupTableFilterSortViewModelArgs<TData extends GroupTableMetrics> = {
    data: TData[];
    page: number;
    rowsOnPage: number;
    setPage: (page: number) => void;
    setPageCount: (count: number) => void;
    setTotalRows: (count: number) => void;
    filterData: (item: TData) => boolean;
    sortComparators: GroupTableCustomSortComparators<TData>;
};

export const useGroupTableFilterSortViewModel = <TData extends GroupTableMetrics>({
    data,
    page,
    rowsOnPage,
    setPage,
    setPageCount,
    setTotalRows,
    filterData,
    sortComparators,
}: UseGroupTableFilterSortViewModelArgs<TData>) => {
    const sortData = useCallback(
        (items: TData[], sortKey: keyof TData, direction: SortDirection) =>
            sortGroupTableWithComparators({
                items,
                sortKey,
                direction,
                comparators: sortComparators,
            }),
        [sortComparators],
    );

    return useGroupTableViewModelCore<TData>({
        data,
        page,
        rowsOnPage,
        setPage,
        setPageCount,
        setTotalRows,
        filterData,
        sortData,
    });
};
